import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { ApiClientService } from './api-client.service';
import { I18n } from '../shared/i18n';
import { Observable } from 'rxjs/Observable';

let moment = I18n.moment;

@Injectable()
export class ApiAvailableDatesService {
  public availableDates = new BehaviorSubject<Object>({
    //maxDay: null,
    //maxWeek: null,
    maxMonth: null,
    maxYear: null,
    //minDay: null,
    //minWeek: null,
    minMonth: 1,
    minYear: 2008,
    legacyMaxMonth: 12,
    legacyMaxYear: 2016
  });

  private availableDatesEndpoint = '/available_dates';

  constructor(private apiClientService: ApiClientService) {
    this.fetch();
  }

  public fetch() {
    this.apiClientService.get(this.availableDatesEndpoint)
      .subscribe((data: any) => {
        this.availableDates.next({
          maxMonth: data.maxMonth,
          maxYear: data.maxYear,
          minMonth: 1,
          minYear: 2008,
          legacyMaxMonth: 12,
          legacyMaxYear: 2016
        });
      });
  }

  public generateMoment(): Observable<any> {
    return Observable.create(observer => {
      this.availableDates
      .subscribe((availableDates: any) => {
        if (availableDates.maxYear && availableDates.maxMonth) {
          observer.next(moment().year(availableDates.maxYear).month(availableDates.maxMonth - 1).startOf('month'));
          observer.complete();
        }
      });
    });
  }
}
